import {
  Component, Input, Output, EventEmitter, HostBinding,
  ChangeDetectorRef, OnChanges, SimpleChanges,
} from '@angular/core';

import { LACT } from './list-actions.config';


@Component({
  moduleId: module.id,
  selector: 'list-actions',
  templateUrl: 'list-actions.component.html',
  styleUrls: ['list-actions.component.scss'],
})
export class ListActionsComponent implements OnChanges {
  @Input() displayDropdown: boolean = false;
  @Input() dropup: boolean = true;

  @Output() actionSelected = new EventEmitter();

  @HostBinding('attr.data-ghost')
  dataGhost: string = 'list-actions';

  listActions = [
    LACT.ADD_TO_LIST,
    LACT.REMOVE_FROM_LIST,
  ];

  constructor(protected ref: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.displayDropdown) {
      this.ref.detectChanges();
    }
  }

  onAddToListClick() {
    this.actionSelected.emit(this.listActions[0]);
  }

  onSelectedChange($event: any) {
    this.actionSelected.emit($event);
  }
}
